<template>
  <portal to="root">
    <div
      v-if="isOpen"
      :class="[
        $style.PWCropper,
        'pw-cropper'
      ]"
    >
      <div :class="$style.PWCropperCtx">
        <section :class="$style.PWCropperBody">
          <Cropper
            ref="cropper"
            :src="src"
            :resize-image="{
              adjustStencil: false,
            }"
            :stencil-props="{
              movable: false,
              resizable: false,
              aspectRatio: aspectRatio,
              handlers: {},
              lines: {},
            }"
            image-restriction="stencil"
            @ready="handleReady"
          />
        </section>
        <div
          v-show="isLoaded"
          :class="$style.PWCropperFooter"
        >
          <PWButton
            variant="outline"
            size="medium"
            @click="handleClose"
          >
            Сбросить
          </PWButton>
          <PWButton
            size="medium"
            @click="handleSave"
          >
            Сохранить
          </PWButton>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import PWButton from '@/components/_ui/Buttons/PWButton.vue'
import 'vue-advanced-cropper/dist/style.css'

export default {
  controls: { resolve: null, reject: null },
  components: {
    Cropper,
    PWButton
  },
  data: () => ({
    src: '',
    filename: '',

    isOpen: false,
    isLoaded: false,
    aspectRatio: 1
  }),
  methods: {
    open ({ file, aspectRatio }) { // ref method
      this.aspectRatio = aspectRatio || 1

      let resolve
      let reject
      // eslint-disable-next-line promise/param-names
      const promise = new Promise((ok, fail) => {
        resolve = ok
        reject = fail
      })

      this.$options.controls = { resolve, reject }
      this.src = URL.createObjectURL(file)
      this.filename = file.name
      this.isOpen = true

      return promise
    },

    reset () { // ref method
      this.isLoaded = false
      this.isOpen = false
      this.filename = ''
      URL.revokeObjectURL(this.src)
    },

    close () { // ref method
      this.$options.controls.resolve(null)
      this.reset()
    },

    handleClose () {
      if (this.isLoaded) {
        this.close()
      }
    },

    handleSave () {
      const { canvas } = this.$refs.cropper.getResult()

      canvas.toBlob((blob) => {
        const filenameWithoutExtension = this.filename.replace(/\.[^/.]+$/, '')
        const file = new File([blob], filenameWithoutExtension + '.png', {
          type: 'image/png'
        })
        this.$options.controls.resolve(file)

        this.reset()
      }, 'image/png', 0.8)
    },

    handleReady () {
      this.isLoaded = true
    }
  }
}
</script>

<style lang="scss">
.pw-cropper .vue-rectangle-stencil::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px dashed white;
  opacity: 0.5;
}
</style>

<style module lang="scss">
.PWCropper {
  position: fixed;
  z-index: 99;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  border: 4px solid black;
  background-color: black;
  display: flex;
  overflow: hidden;
  box-sizing: var(--shadow-xl);
}

.PWCropperCtx {
  position: relative;
}

.PWCropperBody {
  position: relative;
  display: flex;
  justify-content: center;
  width: 600px;
  height: 400px;
}

.PWCropperFooter {
  position: relative;
  padding: 8px;
  display: flex;
  justify-content: center;
  gap: 8px;
}
</style>
